import React from 'react';

export default props => (
  <svg {...props} viewBox="0 0 80 80">
    {props.children}
    <path
      fill="#F4EEE6"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m39 3 2 1.1 1.6.8L47.3.2l2.2 1.1-.3 3.2 5-2.4 2.2 1L54 8l4.4.2 2.2 1-4.4 5.5 3.1 2.8-3.8 6 1.2 5-4.9 4.4L51 39l-5 2.1-2.8 6.5-6.5 6-2-1-3-3.2-2.8 4.7-2.1-1-1-5.3-2.8 2.3-2-1.1 1.2-6.3-1.7-.5-2.1-1.1 3-6.4-2.1-4 4.4-5.3-.1-5.7 5-3.4 2-6.4 4.7-.8L38.9 3Z"
    />
    <path
      fill="#FAF5EF"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m41 4.1 3.7 2 4.8-4.8 1.9 4.3 5-2.5-.1 6 4.4.1-2.2 6.5 3 2.9-3.8 6 1.2 5-4.8 4.3-1 6.3-4.9 2.1-2.8 6.5-4.3-.6-4.3 5.5-2.9-3.1-5 3.6L28 49l-4.8 1.2 1.2-6.4-3.8-1.5 3-6.4-2.1-4 4.4-5.3-.2-5.7 5-3.4 2-6.5 4.7-.8 3.7-6Z"
    />
    <path
      fill="#FAF5EF"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M32.7 33.2v46.5l12-13.9 9.2 1.6V20.8L32.7 33.2Z"
    />
    <path fill="#fff" d="M38 30v36.7l6-9 4.5 2.8V24L38 30.1Z" />
    <path
      fill="#FAF5EF"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M32.6 47.6v32.1l-2.4-1.3V46.2l2.4 1.4Z"
    />
    <path
      fill="#F4EEE6"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M54.3 12.3 49.5 10c-2.7-1.1-6.3-.6-10.3 2a31 31 0 0 0-13.6 25.6c.2 4.5 2 7.5 4.7 8.7l3.4 1.8c-2.8-1.2-.5-2.8-.7-7.3a32.6 32.6 0 0 1 13.7-25.5c4-2.7 4.9-4.2 7.6-3Z"
    />
    <path
      fill="#FAF5EF"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M53.7 12c6.4 2.8 7.4 13.2 2 23.3-5.3 10-14.9 16-21.3 13.1-6.5-2.8-7.5-13.2-2.1-23.3 5.3-10 14.9-16 21.4-13.1Z"
    />
    <path
      fill="#fff"
      stroke="#FAF5EF"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M54.2 34.6a25 25 0 0 0 3.2-13.5c-.4-3.9-2-6.5-4.5-7.6-2.5-1-5.9-.6-9.4 1.6a28 28 0 0 0-9.6 10.7 25 25 0 0 0-3.2 13.5c.3 3.9 2 6.5 4.5 7.6 2.5 1.1 5.8.6 9.4-1.6 3.5-2.2 7-5.9 9.6-10.7Z"
    />
    <path fill="#F4EEE6" d="m44.5 19.2 1.8 6.2 6.2-3.6-5 8.4L49 37l-4.6-2.6-5.7 8.5 2.2-9-5.7-1.4 7-4.7 2.2-8.5Z" />
  </svg>
);
